import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";

@Component({
    selector: "app-commercial-map",
    templateUrl: "./commercial-map.component.html",
    styleUrl: "./commercial-map.component.scss",
    imports: [RouterModule],
})
export class CommercialMapComponent {}
